import React from 'react';

const CatcherGameInst = () => {
  return (
    <div className="absolute inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm animate-fade-in">
      <div className="w-[85%] max-w-[320px] bg-black/40 border border-white/10 rounded-2xl p-6 text-center shadow-2xl backdrop-blur-md relative overflow-hidden">
        {/* Background glow effect */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-32 bg-blue-500/20 rounded-full blur-3xl -z-10"></div>

        <div className="mb-5 flex justify-center">
          <div className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center border border-white/20 shadow-inner">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-8 h-8 text-white animate-pulse"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M7.5 21L3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5"
              />
            </svg>
          </div>
        </div>

        <h2 className="text-xl font-bold text-white mb-2 tracking-wide">
          How to Play
        </h2>
        <p className="text-gray-200 text-sm leading-relaxed font-medium">
          <span className="text-[#17b978] font-bold">Swipe</span> left or right
          to collect
          <br />
          the falling objects to score!
        </p>

        {/* Progress bar for auto-start */}
        <div className="mt-6">
          <div className="flex justify-between text-[10px] text-gray-400 mb-1 uppercase tracking-wider font-bold">
            <span>Starting Game</span>
          </div>
          <div className="h-1.5 w-full bg-white/10 rounded-full overflow-hidden">
            <div
              className="h-full bg-gradient-to-r from-blue-400 to-[#17b978] rounded-full"
              style={{
                width: '100%',
                animation: 'progress 4s linear forwards',
                transformOrigin: 'left',
              }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CatcherGameInst;
